module.exports = __webpack_public_path__ + "img/vip-bg.68b1e97a.png";